export default __webpack_public_path__ + "static/PT-2fd3c63b1e319b37691930a6c9b2e7c8.svg";